import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LibraryAPIResponse } from '../../../types/responses';
import { CoreModule } from '../../core.module';
import { ServerConnectionService } from '../server-connection.service';

@Injectable({
	providedIn: CoreModule,
})
export class LibraryService {
	constructor(
		private scs: ServerConnectionService,
	) {}

	fetch(url: string): Observable<LibraryAPIResponse> {
		return this.scs.post$('/api/library/fetch-open-graph', { url });
	}
}
